import { fromNode, ViewModel } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { CSSStyleSheetNode } from './TypedNode'

export class CSSStyleSheetModel extends ViewModel {
  @fromNode()
  @reactive()
  rules: string = ''

  constructor(node: CSSStyleSheetNode) {
    super(node)
    this.addEffect(
      () => {
        const style = document.createElement('style')
        style.textContent = this.rules
        document.head.append(style)
        return () => {
          style.remove()
        }
      },
      {
        immediately: true
      }
    )
  }
}
